// ============================================
// Shared utilities for PlaceAutocompleteInput
// ============================================

/** Threshold in meters below which we show meters instead of km */
const METRIC_SMALL_THRESHOLD = 1000;

/** Threshold in meters below which we show feet instead of miles (~0.1 miles) */
const IMPERIAL_SMALL_THRESHOLD = 160;

/** Meters per mile */
const METERS_PER_MILE = 1609.344;

/** Meters per foot */
const METERS_PER_FOOT = 0.3048;

export type DistanceUnitSystem = "km" | "mi";

/**
 * Format a distance in meters to a human-readable string.
 * Automatically picks the best sub-unit based on magnitude:
 * - Metric: "250 m" or "1.2 km"
 * - Imperial: "350 ft" or "0.8 mi"
 */
export const formatDistance = (
  distanceMeters: number,
  unit: DistanceUnitSystem
): string => {
  if (unit === "mi") {
    if (distanceMeters < IMPERIAL_SMALL_THRESHOLD) {
      const feet = Math.round(distanceMeters / METERS_PER_FOOT);
      return `${feet} ft`;
    }
    const miles = distanceMeters / METERS_PER_MILE;
    return miles < 10
      ? `${miles.toFixed(1)} mi`
      : `${Math.round(miles)} mi`;
  }

  // Metric
  if (distanceMeters < METRIC_SMALL_THRESHOLD) {
    return `${Math.round(distanceMeters)} m`;
  }
  const km = distanceMeters / 1000;
  return km < 10
    ? `${km.toFixed(1)} km`
    : `${Math.round(km)} km`;
};